export function PlaceholderScreen({ title }: { title: string }) {
  return (
    <div className="flex flex-col gap-2">
      <h1 className="text-title font-semibold">{title}</h1>
      <p className="text-body text-text-secondary">
        Not yet implemented. See docs/design-prds for the screen brief and
        docs/frontend-prds for the implementation PRD once written.
      </p>
    </div>
  )
}
